import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IChatWidgetProfile {
  title?: string;
  subtitle?: string;
  botName?: string;
  logoUrl?: string;
  botAvatarUrl?: string;
  width?: number;
  height?: number;
}

interface IChatWidgetStore {
  /** Serviço de Tickets do 4uChat do site. null = site sem chat. */
  ticketServiceId: string | null;
  /** Modo padrão de abertura definido no serviço (tela cheia ou balão). */
  fullScreenMode: boolean;
  profile: IChatWidgetProfile;
}

const CHAT_WIDGET_INITIAL_STATE: IChatWidgetStore = {
  ticketServiceId: null,
  fullScreenMode: false,
  profile: {},
};

export const slice = createSlice({
  name: "chatWidget",
  initialState: CHAT_WIDGET_INITIAL_STATE,
  reducers: {
    setChatWidget(
      state: IChatWidgetStore,
      action: PayloadAction<IChatWidgetStore>
    ) {
      return { ...state, ...action.payload };
    },
  },
});

export const chatWidgetSliceActions = slice.actions;

export default slice.reducer;
